import React, { useEffect, useState } from 'react';
import { ClockIcon, FlameIcon } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50); // 14:50 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 14 * 60 + 50; // Reset when reaches 0
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#9BAF8D] text-white py-1.5 px-4 shadow-sm" data-id="element-78">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-xs font-medium" data-id="element-79">
        <div className="flex items-center gap-2" data-id="element-80">
          <ClockIcon className="w-3 h-3" data-id="element-81" />
          <span data-id="element-82">⏳ OFERTA EXPIRA EN:</span>
          <span className="font-bold bg-white/20 px-1.5 py-0.5 rounded" data-id="element-83">
            {timeLeft > 0 ? formattedTime : '¡EXPIRADA!'}
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-84">
          <FlameIcon className="w-3 h-3 text-white" data-id="element-85" />
          <span className="font-bold" data-id="element-86">SOLO QUEDAN 3 CUPOS</span>
        </div>
      </div>
    </div>;
}